var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28033 1.21967C1.98744 0.926777 1.51256 0.926777 1.21967 1.21967C0.926777 1.51256 0.926777 1.98744 1.21967 2.28033L2.28033 1.21967ZM17.7197 18.7803C18.0126 19.0732 18.4874 19.0732 18.7803 18.7803C19.0732 18.4874 19.0732 18.0126 18.7803 17.7197L17.7197 18.7803ZM18.7803 2.28033C19.0732 1.98744 19.0732 1.51256 18.7803 1.21967C18.4874 0.926777 18.0126 0.926777 17.7197 1.21967L18.7803 2.28033ZM1.21967 17.7197C0.926777 18.0126 0.926777 18.4874 1.21967 18.7803C1.51256 19.0732 1.98744 19.0732 2.28033 18.7803L1.21967 17.7197ZM1.21967 2.28033L9.46967 10.5303L10.5303 9.46967L2.28033 1.21967L1.21967 2.28033ZM9.46967 10.5303L17.7197 18.7803L18.7803 17.7197L10.5303 9.46967L9.46967 10.5303ZM17.7197 1.21967L9.46967 9.46967L10.5303 10.5303L18.7803 2.28033L17.7197 1.21967ZM9.46967 9.46967L1.21967 17.7197L2.28033 18.7803L10.5303 10.5303L9.46967 9.46967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x_icon.ac49f22f7f42f882f20097a6377c0353.svg";
export { ForwardRef as ReactComponent };